import { render, staticRenderFns } from "./Poopee.vue?vue&type=template&id=01ddb1a2&"
import script from "./Poopee.vue?vue&type=script&lang=js&"
export * from "./Poopee.vue?vue&type=script&lang=js&"
import style0 from "./Poopee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports